<div class="border-l-4 border-gray-800 bg-yellow-50 p-4 rounded-md">
  <div class="flex items-center gap-3 text-yellow-800">
    <mat-icon class="!overflow-visible">error_outline</mat-icon>
    <div>
      @if (label(); as label) {
        <p class="font-semibold">{{ label }}</p>
      }
      <p class="text-sm text-yellow-700"><ng-content></ng-content></p>
    </div>
  </div>
</div>
